import React, { useState, useEffect, useContext } from 'react';
import { Comment, Divider } from 'antd';

import ProfileAvatar from '../common/ProfileAvatar';
import Editor from './Editor';
import CommentList from './CommentList';
import UserContext from '../../context/UserContext';
import {callApi} from '../../helpers/Api';

const MyComment = (props) => {
    const {loggedInUser} = useContext(UserContext);
    const [comments, setComments] = useState([])

    useEffect(() => {
        callApi('/api/story_comment/story/' + props.storyId)
        .then(json => {
            for (var i = 0; i < json.length; i++) { 
                json[i].isNewlySubmitted = false;
                json[i].replyHidden = true; 
            } 
            setComments(json)
        })
    }, [props.storyId]);

    return (
        <div style={{width: '100%'}}>
            <Divider orientation="left"><p className="text-darkable">{comments.length + ' comments'}</p></Divider>
            <Comment
                avatar={
                    <ProfileAvatar 
                        shape="square"
                        size={32}
                        alt={loggedInUser?.username}
                        avatarUrl={loggedInUser?.profile_picture}
                    />
                }
                content={
                    <Editor
                        parentId={null}
                        storyId={props.storyId}
                        path={props.storyId}
                        handleSubmitRes={(res) => {
                            setComments([
                                {
                                    ...res, ...{
                                        username: loggedInUser.username,
                                        profile_picture: loggedInUser.profile_picture,
                                        user_account_id: loggedInUser.id,
                                        isNewlySubmitted: true,
                                        replyHidden: true,
                                        like_dislike: null,
                                        like_dislike_created_at: null,
                                        like_dislike_id: null,
                                        likes: null,
                                        dislikes: null,
                                    }
                                },
                                ...comments,
                            ])
                        }}
                        {...props}
                    />
                }
            />
            {comments.length > 0 && <CommentList 
                storyId={props.storyId} 
                authorId={props.authorId}
                comments={comments} 
                setComments={setComments}
                scrollTo={props.scrollTo ? props.scrollTo : null}
                {...props}
            />}
        </div>
    );
}

export default MyComment;